import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#8b5cf6' // soft royal purple
    },
    secondary: {
      main: '#f97316'
    },
    background: {
      default: '#f5f5f7',
      paper: '#ffffff'
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained'
      }
    }
  }
});

